import { Claim, ClaimControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  claim: Claim;
  xTENANTID?: string;
}

export const useAddClaims = () =>
  useMutationWithLoading(async (params: Params) =>
    new ClaimControllerApi(getConfigObject()).createClaim1(
      params.claim,
      params.xTENANTID
    )
  );
